<template>
  <div style="height: 600px; width: 100%; margin-bottom: 35px;">
    <img :src="src"/>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  props: {
    src: {
      required: true
    },

    options: {
      type: Object,
      default: () => window.CroppieOptions
    }
  },

  data() {
    return {
      croppedImage: null
    };
  },

  mounted() {
    this.cropper = new Cropper(this.$el.children[0], this.options);
  },

  destroyed() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  },

  watch: {
    src() {
      this.$nextTick(() => {
        this.cropper = new Cropper(this.$el, this.options);
      });
    },

    croppedImage(image) {
      if (image) {
        this.$emit("cropped", image);
      }
    }
  },

  methods: {
    crop() {
      this.cropper
        .getCroppedCanvas({width: 800, height: 800})
        .toBlob(this.cropped, this.outputFormat());
    },

    cropped(blob) {
      this.croppedImage = blob;
    },

    outputFormat() {
      return 'output' in this.options
        ? this.options.output
        : "image/jpeg";
    }
  },
};
</script>
